// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"b8b9b8dc","639":"cf452f0f","704":"c31f15b7","864":"2f2db399"}[chunkId] + ".chunk.css";
};